<template>
  <div>

    <div class="alert alert-info" role="alert" v-if="is_archived">
      <i :class="icon_status_plan"></i>
      {{ __("forms.KPIIncentivePlan.element_related_to_plan_archived_info") }}
    </div>

    <input type="hidden" name="_token" :value="csrf" />
    <input v-if="this.editing" type="hidden" name="_method" value="PUT" />
    <div class="row px-3 mt-5" v-if="
      show_ral ||
      show_target_bonus ||
      show_target_euro ||
      show_prize_assigned ||
      show_prize_reached ||
      show_prize_final ||
      show_sum_percent_reach_for_weight
    ">
      <div class="col-12 col-md-6 col-lg-6 mb-4" v-if="show_ral">
        <div class="card p-2 border-card shadow">
          <p class="font-weight-bold">{{ pay_item_ral_name }}</p>
          <p class="text-right h3 text-muted">{{ userRal }} €</p>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-6 mb-4" v-if="show_target_bonus">
        <div class="card p-2 border-card shadow">
          <div v-if="!read_target">
            <div v-if="prize_mode == 'weight_percentage' && permission_add >= 1">
              <p class="font-weight-bold">
                {{ __("forms.KPIPeople.target_bonus") }}
              </p>
              <input class="form-control" v-model="targetBonus" type="number" step="0.01"
                @change="updateTargetBonusPerson()" :disabled="is_archived" />
            </div>
            <div v-else>
              <p class="font-weight-bold">
                {{ __("forms.KPIPeople.target_bonus") }}
              </p>
              <p class="text-right h3 text-muted">
                {{ targetBonus }} %
              </p> 
            </div>
          </div>
          <div v-else>
            <p class="font-weight-bold">
              {{ __("forms.KPIPeople.target_bonus") }}
            </p>
            <p class="text-right h3 text-muted">
              {{ targetBonus }} %
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-6 mb-4" v-if="show_target_euro">
        <div class="card p-2 border-card shadow">
          <div v-if="!read_target">
            <div v-if="prize_mode == 'weight_percentage' && permission_add >= 1">
              <p class="font-weight-bold">
                {{ __("forms.KPIPeople.target_euro") }}
              </p>
              <input class="form-control" v-model="targetEuro" step="0.01" type="number"
                @change="updateTargetEuroPerson()" placeholder="€" :disabled="is_archived" />
            </div>
            <div v-else>
              <p class="font-weight-bold">
                {{ __("forms.KPIPeople.target_euro") }}:
              </p>
              <p class="text-right h3 text-muted">
                {{ targetEuroEnchanted }}
              </p>
            </div>
          </div>
          <div v-else>
            <p class="font-weight-bold">
              {{ __("forms.KPIPeople.target_euro") }}:
            </p>
            <p class="text-right h3 text-muted">
              {{ targetEuroEnchanted }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="show_prize_assigned" class="col-12 col-md-6 col-lg-6 mb-4">
        <div class="card p-2 border-card shadow">
          <p class="font-weight-bold">
            {{ __("forms.KPIPeople.bonus_sum_assigned") }}:
          </p>
          <p class="text-right h3 text-muted">{{ sumPrize }} €</p>
        </div>
      </div>
      <div v-if="show_sum_percent_reach_for_weight" class="col-12 col-md-6 col-lg-6 mb-4">
        <div class="card p-2 border-card shadow">
          <p class="font-weight-bold">
            {{ __("forms.EvaluationChart.questions.questions_setting.question12.summary.sum_percent_reach_for_weight")
            }}:
          </p>
          <p class="text-right h3 text-muted">{{ sumPercentReachForWeight }} %</p>
        </div>
      </div>
      <div v-if="show_gross_bonus_sum_achieved_on_ral" class="col-12 col-md-6 col-lg-6 mb-4">
        <div class="card p-2 border-card shadow">
          <p class="font-weight-bold">
            {{ __("forms.KPIPeople.gross_bonus_sum_achieved") }}
          </p>
          <p class="text-right h3 text-muted">
            {{ grossBonusSumAchievedOnRal }} %
          </p>
        </div>
      </div>
      <div v-if="show_gross_bonus_sum_achieved_plus_internal_conditions_on_ral" class="col-12 col-md-6 col-lg-6 mb-4">
        <div class="card p-2 border-card shadow" :title="__('forms.KPIPeople.gross_bonus_sum_achieved_plus_internal_conditions_on_ral') + ': ' + grossBonusSumAchievedPlusInternalConditionsOnRal + ' %'">
          <p class="font-weight-bold">
            {{ __("forms.KPIPeople.gross_bonus_sum_achieved_plus_internal_conditions_on_ral") }}
          </p>
          <p class="text-right h3 text-muted">
            {{ prettyGrossBonusSumAchievedPlusInternalConditionsOnRal }} %
          </p>
        </div>
      </div>
      <div v-if="show_prize_reached" class="col-12 col-md-6 col-lg-6 mb-4">
        <div class="card p-2 border-card shadow">
          <p class="font-weight-bold">
            {{ __("forms.KPIPeople.bonus_sum_reached") }}
          </p>
          <p class="text-right h3 text-muted">{{ sumRepartedPrize }} €</p>
        </div>
      </div>
      <div v-if="show_prize_final" class="col-12 col-md-6 col-lg-6 mb-4">
        <div class="card p-2 border-card shadow">
          <p class="font-weight-bold">
            {{ __("forms.KPIPeople.bonus_sum_final") }}
          </p>
          <p class="text-right h3 text-muted">{{ sumPrizeFinal }} €</p>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12" v-if="tableThreshold.length > 0">
        <div class="row px-3">
          <div class="col-12">
            <h3 class="font-weight-bold mb-2">
              {{ __("forms.mbo.thesholdIntern") }}
            </h3>
          </div>
          <div class="col-12">
            <table class="table table-custom-header" style="overflow: hidden; width: 100%">
              <thead>
                <tr>
                  <th class="font-weight-bold">
                    {{
                      __("forms.EvaluationChart.questions.questions_setting.question12.threshold.name")
                    }}
                  </th>
                  <th class="font-weight-bold">
                    {{
                      __(
                        "forms.EvaluationChart.questions.questions_setting.question12.tableKPI.targetCurrency",
                      )
                    }}
                  </th>
                  <th class="font-weight-bold" v-if="show_max_min_targets">
                    {{
                      __(
                        "forms.EvaluationChart.questions.questions_setting.question12.threshold.area_performance",
                      )
                    }}
                  </th>
                  <th class="font-weight-bold">
                    {{ __("forms.PayItemsPeople.unit_of_measure") }}
                  </th>
                  <th class="font-weight-bold">
                    {{
                      __(
                        "forms.EvaluationChart.questions.questions_setting.question12.threshold.consumptive",
                      )
                    }}
                  </th>
                  <th class="font-weight-bold">
                    {{
                      __(
                        "forms.EvaluationChart.questions.questions_setting.question12.external_conditions.result",
                      )
                    }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in tableThreshold" :key="row.name">
                  <td>{{ row.name }}</td>
                  <td>{{ row.targetCurrency }}</td>
                  <td v-if="show_max_min_targets">
                    {{ row.area_performance }}
                  </td>
                  <td>{{ row.unit_measure }}</td>
                  <td>{{ row.consumptive }}</td>
                  <td>{{ row.percent }} %</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="show_external_conditions.length > 0">
        <div class="row px-3">
          <div class="col-12">
            <h3 class="font-weight-bold mb-2">
              {{
                __(
                  "forms.EvaluationChart.questions.questions_setting.question12.external_conditions.title",
                )
              }}
            </h3>
          </div>
          <div class="col-12">
            <table class="table table-custom-header" style="overflow: hidden; width: 100%">
              <thead>
                <tr>
                  <th class="font-weight-bold">
                    {{
                      __(
                        "forms.EvaluationChart.questions.questions_setting.question12.external_conditions.name",
                      )
                    }}
                  </th>
                  <th class="font-weight-bold">
                    {{
                      __(
                        "forms.EvaluationChart.questions.questions_setting.question12.external_conditions.value",
                      )
                    }}
                  </th>
                  <th class="font-weight-bold">
                    {{
                      __(
                        "forms.EvaluationChart.questions.questions_setting.question12.external_conditions.result",
                      )
                    }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in tableExternalConditions" :key="row.name">
                  <td v-if="show_external_conditions.includes(row.id)">
                    <span v-if="row.description.length > 0">
                      <i class="fas fa-info-circle text-info colored-icon" 
                        :title="row.description"
                        @click="showExternalConditionDescription(row)"
                      >
                      </i>
                    </span>
                    {{ row.name }}
                  </td>
                  <td v-if="show_external_conditions.includes(row.id)">
                    {{ row.value }}
                  </td>
                  <td v-if="show_external_conditions.includes(row.id)">
                    {{ row.percent }}<span v-if="row.percent !== '---'"> %</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="discretionaryPrizeData != null && discretionaryPrizeData.value > 0">
          <div class="row px-3">
            <div class="col-12">
              <h3 class="font-weight-bold mb-2">
                  {{ __('forms.KPIPeople.discretionary_prize') }}
              </h3>
            </div>
            <div class="col-12">
              <table class="table table-custom-header" style="overflow: hidden; width: 100%">
                <thead>
                  <tr>
                    <th class="font-weight-bold">
                      {{ __('forms.personKPIDiscretionaryPrize.value') }}
                    </th>
                    <th class="font-weight-bold">
                      {{ __('forms.personKPIDiscretionaryPrize.note') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ discretionaryPrizeData.value }} €</td>
                    <td>{{ discretionaryPrizeData.note }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
      </div>
    </div>
    <div class="form-group" v-if="alerts.length > 0">
      <label>{{ __("forms.KPIS.alerts") }}:</label>
      <p v-for="(alertMessage, ind) in alerts" :key="ind">
        <i class="fas fa-exclamation-triangle" style="color: red"></i>
        {{ alertMessage }}
      </p>
    </div>

    <!-- Bottoni sopra la tabella -->
    <div class="mt-5">
      <div class="row px-3">
        <div class="col-12 col-md-6">
          <h3 class="mb-3 font-weight-bold">
            {{ __("forms.KPIS.mbo_assigned") }}
          </h3>
        </div>
        <div class="col-12">
          <span v-if="permission_add_new_kpi >= 1 && !is_archived" @click="openAddNewKpi" class="btn btn--green"
            style="border-radius: 8px" data-toggle="tooltip" data-placement="top" title="Add new KPI">
            <i class="fas fa-plus-circle"></i>
            {{ __("views.KPIs.add_new_kpi") }}
          </span>
          <span href="#" v-if="permission_add >= 1 && !is_archived" @click="openAddExistingKpi" class="btn btn--green"
            style="border-radius: 8px" data-toggle="tooltip" data-placement="top" title="Add existing KPI">
            <i class="fas fa-list-ul"></i>

            {{ __("views.KPIs.add_kpi_existing_on_chart") }}
          </span>
          <button class="btn btn--green" type="button" @click="plot" v-if="show_pie_graph || show_line_chart">
            <i class="fas fa-chart-line"></i>
            {{
              showPlots
                ? __("views.Employee.charts.hideGraphs")
                : __("views.Employee.charts.showGraphs")
            }}
          </button>
        </div>
      </div>

      <div v-if="show_pie_graph || show_line_chart">
        <div class="row px-3 align-middle" :style="{
          height: showPlots ? 'auto' : '0px',
          overflowY: showPlots ? 'auto' : 'hidden',
        }">
          <div :class="(show_pie_graph) && (show_line_chart) ? 'col-6 align-self-center mb-5' : 'col-12 mb-5'
            " :style="(show_pie_graph) && (show_line_chart) ? 'height: 350px' : ''">
            <line-evaluation-chart v-if="show_line_chart" :ref="'mbo_line_targets_' + this.question_survey_id"
              title_text="Avanzanzamento KPI" :maintainAspectRatio="false">
            </line-evaluation-chart>
          </div>

          <div :class="(show_pie_graph) && (show_line_chart)
            ? 'col-6 align-self-center mb-5'
            : 'col-12 align-self-center mb-5'
            ">
            <pie-evaluation-chart v-if="show_pie_graph" :ref="'mbo_pie_targets_' + this.question_survey_id"
              title_text="Suddivisione KPI">
            </pie-evaluation-chart>
          </div>
        </div>
      </div>

      <div class="container-fluid mt-5">
        <div class="row">
          <div class="col-12">
            <div class="sorted-kpi-table">
              <!-- Header -->
              <div class="kpi-table-header row no-gutters border-bottom bg-light py-2">
                <template v-for="(column, index) in columns_order">
                  <div v-if="column === 'show_objective'" :key="column" class="col font-weight-bold px-2">
                    {{ __("forms.KPIPeople.objective") }}
                  </div>

                  <div v-if="(column === 'has_shareable_kpi' && hasShareableKPI)" :key="column"
                    class="col font-weight-bold cursor-pointer px-2" :title="__('misc.sharing')">
                    {{ __("misc.sharing") }}
                  </div>

                  <div v-if="column === 'show_unit_measure' && show_unit_measure" :key="column"
                    class="col font-weight-bold cursor-pointer px-2" :title="__('forms.KPIS.unit_measure')">
                    {{ __("forms.KPIS.unit_measure") }}
                  </div>

                  <div v-if="column === 'show_measures_and_formulas' && show_measures_and_formulas" :key="column"
                    class="col font-weight-bold cursor-pointer px-2" :title="__('forms.KPIS.measuers_and_formulas')">
                    {{ __("forms.KPIS.measuers_and_formulas") }}
                  </div>

                  <div v-if="column === 'show_categories_on_create_kpi' && show_categories_on_create_kpi" :key="column"
                    class="col font-weight-bold cursor-pointer px-2" :title="__('forms.KPIS.categories')">
                    {{ __("forms.KPIS.categories") }}
                  </div>

                  <div v-if="column === 'show_kpi_classification_in_chart' && show_kpi_classification_in_chart" :key="column"
                    class="col font-weight-bold cursor-pointer px-2" :title="__('forms.KPIS.classification')">
                    {{ __("forms.KPIS.classification") }}
                  </div>

                  <div v-if="column === 'show_kpi_esg_in_chart' && show_kpi_esg_in_chart" :key="column"
                    class="col font-weight-bold cursor-pointer px-2" :title="__('forms.KPIS.esgList')">
                    {{ __("forms.KPIS.esgList") }}
                  </div>

                  <div v-if="column === 'show_typology' && show_typology" :key="column"
                    class="col font-weight-bold cursor-pointer px-2" :title="__('forms.KPIPeople.indicator')">
                    {{ __("forms.KPIPeople.indicator") }}
                  </div>

                  <div v-if="column === 'show_target_100' && show_target_100" :key="column"
                    class="col font-weight-bold cursor-pointer px-2" :title="__('forms.KPIPeople.target')">
                    {{ __("forms.KPIPeople.target") }}
                  </div>

                  <div v-if="column === 'show_target_min_max' && show_max_min_targets" :key="column"
                    class="col font-weight-bold cursor-pointer px-2" :title="__('forms.KPIPeople.min_performance') +
                      ' / ' +
                      __('forms.KPIPeople.max_performance')">
                    {{ __("forms.KPIPeople.min_performance") }} /
                    {{ __("forms.KPIPeople.max_performance") }}
                  </div>

                  <div v-if="column === 'show_prizes_min_max' && show_max_min_prizes" :key="column" :title="__('forms.KPIPeople.min_prize') +
                    ' / ' +
                    __('forms.KPIPeople.max_prize')
                    " class="col font-weight-bold cursor-pointer px-2">
                    {{ __("forms.KPIPeople.min_prize") }} /
                    {{ __("forms.KPIPeople.max_prize") }}
                  </div>

                  <div v-if="column === 'show_set_consumptive' && show_set_consumptive >= 1" :key="column"
                    class="col font-weight-bold cursor-pointer px-2" :title="__('forms.KPIS.update_consumptive')">
                    {{ __("forms.KPIS.update_consumptive") }}
                  </div>

                  <div v-if="column === 'show_prize_attribute' && show_prize_attribute" :key="column" class="col font-weight-bold cursor-pointer px-2"
                    :title="prize_name">
                    {{ prize_name }}
                    <span v-if="prize_mode == 'weight_percentage'">
                      ( {{
                        __('forms.EvaluationChart.questions.questions_setting.question12.prizeNames.total')
                      }} {{ extraPrizeName }}% )
                    </span>
                  </div>

                  <div v-if="column === 'show_performance_percent' && show_performance_percent" :key="column"
                    class="col font-weight-bold cursor-pointer px-2" :title="__('forms.KPISegments.threshold')">
                    {{ __("forms.KPISegments.threshold") }}
                  </div>

                  <div v-if="column === 'show_reach_percent' && show_reach_percent" :key="column"
                    class="col font-weight-bold cursor-pointer px-2" :title="__('forms.KPISegments.percentage')">
                    {{ __("forms.KPISegments.percentage") }}
                  </div>

                  <div v-if="column === 'show_percent_reach_for_weight' && show_percent_reach_for_weight" :key="column"
                    class="col font-weight-bold cursor-pointer px-2"
                    :title="__('forms.KPIIncentivePlan.percent_reach_for_weight')">
                    {{
                      __("forms.KPIIncentivePlan.percent_reach_for_weight")
                    }}
                  </div>

                  <div v-if="column === 'show_perc_linear_performance' && show_perc_linear_performance" :key="column"
                    class="col font-weight-bold cursor-pointer px-2"
                    :title="__('forms.KPIPeople.perc_linear_performance')">
                    {{
                      __("forms.KPIPeople.perc_linear_performance")
                    }}
                  </div>

                  <div v-if="column === 'gross_bonus_sum_achieved_inline' && show_gross_bonus_sum_achieved_inline"
                    :key="column" class="col font-weight-bold cursor-pointer px-2"
                    :title="__('forms.KPIPeople.gross_bonus_achieved_inline')">
                    {{ __("forms.KPIPeople.gross_bonus_achieved_inline") }}
                  </div>

                  <div v-if="column === 'show_bonus_target' && show_bonus_target" :key="column"
                    class="col font-weight-bold cursor-pointer px-2" :title="__('forms.KPIPeople.bonus_prize')">
                    {{ __("forms.KPIPeople.bonus_prize") }}
                  </div>

                  <div v-if="column === 'show_bonus_weight' && show_bonus_weight" :key="column"
                    class="col font-weight-bold cursor-pointer px-2" :title="__('forms.KPIPeople.bonus_reached')">
                    {{ __("forms.KPIPeople.bonus_reached") }}
                  </div>

                  <div v-if="column === 'show_bonus_rep' && show_bonus_rep" :key="column"
                    class="col font-weight-bold cursor-pointer px-2" :title="__('forms.KPIPeople.bonus_final')">
                    {{ __("forms.KPIPeople.bonus_final") }}
                  </div>
                </template>
              </div>

              <!-- Body -->
              <div class="kpi-table-body">
                <div v-for="row in tableKpi" :key="row.id"
                  class="kpi-table-row row no-gutters border-bottom py-2 align-items-center">
                  <template v-for="(column, index) in columns_order">
                    <!-- Objective column -->
                    <div
                      v-if="column === 'show_objective' && (row.isKpiApproved === null || row.isPersonKpiApproved === null)"
                      :key="column" class="col px-2" style="min-height: 65px;">
                      <div>
                        <div class="d-flex">
                          <button
                            v-if="(main_permission > 1) && (permission_add >= 1 || permission_add_new_kpi >= 1) && (!is_archived)"
                            class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove mx-1"
                            type="button" @click="rmKpiRow(row.id)">
                            <i class="fas fa-trash"></i>
                          </button>

                          <button
                            v-if="(main_permission > 1) && (permission_add >= 1 || permission_add_new_kpi >= 1) && (!is_archived)"
                            class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-edit mx-1"
                            type="button" @click="editKpiInfo(row)">
                            <i class="fas fa-pencil"></i>
                          </button>
                        </div>
                        <div class="ml-1">
                          <p style="margin-bottom:0px !important;" class="small text-warning"><i
                              class="fa-solid fa-hourglass-half mr-1"></i>{{ __("forms.KPISegments.onApproving") }}
                          </p>
                          <p class="m-0 text-wrap">{{ row.trimName }}</p>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="column === 'show_objective'" :key="column" class="col px-2" :title="row.name">
                      <div>
                        <div class="d-flex">
                          <button
                            v-if="(main_permission > 1) && (permission_add >= 1 || permission_add_new_kpi >= 1) && row.canPersonHandleKpi && (!is_archived)"
                            class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove mx-1"
                            type="button" @click="rmKpiRow(row.id)">
                            <i class="fas fa-trash"></i>
                          </button>

                          <button
                            v-if="(main_permission > 1) && (permission_add >= 1 || permission_add_new_kpi >= 1) && row.canPersonHandleKpi && (!is_archived)"
                            class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-edit mx-1"
                            type="button" @click="editKpiInfo(row)">
                            <i class="fas fa-pencil"></i>
                          </button>
                        </div>
                        <div class="ml-1">
                          <p class="text-wrap">{{ row.trimName }}</p>
                        </div>
                      </div>
                    </div>

                    <!-- Other columns -->
                    <div v-if="column === 'has_shareable_kpi' && hasShareableKPI" :key="column" class="col px-2">
                      <button v-if="(row.is_kpi_sharable_by_indicator)"
                        class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-info mx-1"
                        type="button" @click="showSharableKpi(row)">
                        <i class="fa-solid fa-users"></i>
                      </button>
                    </div>

                    <div v-if="column === 'show_unit_measure' && show_unit_measure" :key="column" class="col px-2"
                      :title="row.unit_measure">
                      {{ row.unit_measure }}
                    </div>

                    <div v-if="column === 'show_measures_and_formulas' && show_measures_and_formulas" :key="column"
                      class="col px-2">
                      <span @click="showDescriptionKpiAndSegmentationGaols(row)" style="cursor: pointer">
                        <i class="fas fa-info-circle text-info colored-icon"></i></span>
                    </div>

                    <div v-if="column === 'show_categories_on_create_kpi' && show_categories_on_create_kpi" :key="column"
                      class="col px-2">
                      <p v-for="category in row.categories" data-toggle="tooltip" data-placement="top"
                        :title="category">
                        {{ category }}
                      </p>
                    </div>

                    <div v-if="column === 'show_kpi_classification_in_chart' && show_kpi_classification_in_chart" :key="column"
                      class="col px-2">
                      <p data-toggle="tooltip" data-placement="top" :title="row.classification">
                        {{ row.classification }}
                      </p>
                    </div>

                    <div v-if="column === 'show_kpi_esg_in_chart' && show_kpi_esg_in_chart" :key="column" class="col px-2">
                      <p v-for="esg in row.esgs" data-toggle="tooltip" data-placement="top" :title="esg">
                        {{ esg }}
                      </p>
                    </div>

                    <div v-if="column === 'show_typology' && show_typology" :key="column" class="col px-2"
                      :title="row.indicatorName">
                      {{ row.indicatorName }}
                    </div>

                    <div v-if="column === 'show_target_100' && show_target_100" :key="column" class="col px-2"
                      :title="row.targetCurrency">
                      {{ row.targetCurrency }}
                    </div>

                    <div v-if="column === 'show_target_min_max' && show_max_min_targets" :key="column" class="col px-2"
                      :title="row.area_performance">
                      {{ row.area_performance }}
                    </div>

                    <div v-if="column === 'show_prizes_min_max' && show_max_min_prizes" :key="column" class="col px-2"
                      :title="row.area_prize">
                      {{ row.area_prize }}
                    </div>

                    <div v-if="column === 'show_set_consumptive' && show_set_consumptive >= 1" :key="column"
                      class="col px-2" :title="row.consumptive">
                      <span v-if="
                        show_set_consumptive > 1 &&
                        row.canPersonUpdateConsumptiveOfThisKpi &&
                        row.isKpiApproved !== null &&
                        row.isPersonKpiApproved !== null && !isPersonResigned
                      " @click="openTargets(row)">
                        <i class="fas fa-edit text-primary ml-2"></i>
                      </span>
                      <span v-else @click="openTargets(row)">
                        <i class="fas fa-eye text-primary ml-2"></i>
                      </span>
                      <span>{{ row.consumptive }}</span>
                    </div>

                    <div v-if="column === 'show_prize_attribute' && permission_edit_prize > 1 && !lock_weights"
                      :key="column + '_editable'" class="col px-2">
                      <input class="form-control" type="number" @change="updatePrizeAttribute($event, row.id)"
                        :value="row.prizeAttribute" :disabled="is_archived" />
                    </div>
                    <div v-else-if="column === 'show_prize_attribute'" :key="column" class="col px-2" :title="row.prizeAttribute">
                      {{ row.prizeAttribute }}
                    </div>

                    <div v-if="column === 'show_performance_percent' && show_performance_percent" :key="column" class="col px-2"
                      :title="row.gear">
                      {{ row.gear }} %
                    </div>

                    <div v-if="column === 'show_reach_percent' && show_reach_percent" :key="column" class="col px-2"
                      :title="row.percent">
                      {{ row.percent }} %
                    </div>

                    <div v-if="column === 'show_percent_reach_for_weight' && show_percent_reach_for_weight"
                      :key="column" class="col px-2">
                      <span style="position: relative;">
                        {{ row.percentReachForWeight }} %
                        <i class="fa-solid fa-info-circle" style="color: #17a2b8 !important"
                          :title="row.percentReachForWeightNoRound + ' %'"></i>
                      </span>
                    </div>
                    <div v-if="column === 'show_perc_linear_performance' && show_perc_linear_performance"
                      :key="column" class="col px-2">
                      <span style="position: relative;">
                        {{ row.percLinearPerformance }}
                      </span>
                    </div>

                    <div v-if="column === 'gross_bonus_sum_achieved_inline' && show_gross_bonus_sum_achieved_inline"
                      :key="column" class="col px-2" :title="row.gross_bonus_sum_achieved_inline">
                      {{ row.gross_bonus_sum_achieved_inline }} %
                    </div>

                    <div v-if="column === 'show_bonus_target' && show_bonus_target" :key="column" class="col px-2"
                      :title="row.prize">
                      {{ row.prize }}
                    </div>

                    <div v-if="column === 'show_bonus_weight' && row.isPersonKpiApproved && show_bonus_weight"
                      :key="column" class="col px-2" :title="row.repartedPrize">
                      {{ row.repartedPrize }}
                    </div>

                    <div v-if="column === 'show_bonus_rep' && row.isPersonKpiApproved && show_bonus_rep" :key="column"
                      class="col px-2" :title="row.prizeFinal">
                      {{ row.prizeFinal }}
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div v-if="showLoading">
              <p class="w-100 text-center mt-5">
                <i class="fa-solid fa-spinner fa-spin-pulse"></i> {{ __('misc.loading') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div hidden id="kpiInfoPopup">
      <p>
        <b>{{ __("forms.KPIS.name") }}: </b><span id="kpiName"></span>
      </p>
      <p>
        <b>{{ __("forms.KPIS.description") }}: </b><span id="kpiDescription"></span>
      </p>
      <p v-if="is_admin">
        <a id="aBtnGoToSegmentation" target="_blank" href="" class="btn">{{
          __("forms.KPISegments.goToSegmentation")
          }}</a>
        <a id="aBtnGoToKpiGroup" target="_blank" href="" class="btn">{{
          __("forms.KPISegments.goToKpis")
          }}</a>
      </p>
      <table v-if="show_segmentation_info_in_description_modal" id="descriptionSegmentationGoals"
        class="table table-popup">
        <thead>
          <tr>
            <th></th>
            <th>
              <b>{{ __("forms.KPISegments.manualThreshold") }}</b>
            </th>
            <th>
              <b>{{ __("forms.KPISegments.threshold") }}</b>
            </th>
            <th>
              <b>{{ __("forms.KPISegments.percentage") }}</b>
            </th>
            <th>
              <b>{{ __("forms.KPISegments.note") }}</b>
            </th>
            <th>
              <b>{{ __("forms.KPISegments.description") }}</b>
            </th>
          </tr>
        </thead>
        <tbody id="popupSegmentationInfoTr"></tbody>
      </table>
    </div>
    <!--MODAL EDIT KPI-->
    <div class="modal fade" :id="'editKpiModal_' + question_survey_id" tabindex="-1" role="dialog"
      :aria-labelledby="'editKpiModal_' + question_survey_id + 'Modal'" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" :id="'editKpiModal_' + question_survey_id + 'Title'">{{ __("misc.edit") }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="editRowKpi !== null">
              <div class="form-group">
                <label>
                  {{ __("forms.KPIPeople.objective") }}
                </label>
                <input class="form-control" type="text" v-model="editRowKpi.name">
              </div>
              
              <div class="form-group">
                <label>
                  {{ __("forms.KPIS.measuers_and_formulas") }}
                </label>
                <textarea class="form-control" v-model="editRowKpi.measures_and_formulas"></textarea>
              </div>
              
              <div class="form-group" v-if='show_unit_measure'>
                <label>
                  {{ __("forms.KPIS.unit_measure") }}
                </label>
                <textarea class="form-control" v-model="editRowKpi.unit_measure"></textarea>
              </div>

              <div class="form-group" v-if="show_classification_on_create_kpi">
                <label>{{ __("forms.KPIS.classification") }}</label>
                <select class="form-control" v-model="editRowKpi.kpi_classification_id">
                  <option value="" v-if="!required_classification_on_create_kpi">
                    {{ __("forms.EvaluationChart.questions.questions_setting.question12.no_classification") }}
                  </option>
                  <optgroup :label="type.name" v-for="type in classification_types" v-bind:key="type.id">
                    <option v-for="classification in kpi_classifications" v-if="classification.type == type.id"
                      v-bind:key="classification.id" :value="classification.id">
                      {{ classification.name }}
                    </option>
                  </optgroup>
                  <option v-for="classification in kpi_classifications" v-if="classification.type == 0"
                    v-bind:key="classification.id" :value="classification.id">
                    {{ classification.name }}
                  </option>
                </select>
              </div>

              <div class="form-group" v-if="show_esg_on_create_kpi">
                <label>{{ __("forms.KPIS.esgList") }}</label>
                <multiselect v-model="editRowKpi.kpiEsgs" placeholder="Search a tag" label="identifiable_name"
                  track-by="id" :options="kpi_esgs" :multiple="true" :taggable="true"></multiselect>
              </div>

              <div class="form-group" v-if="show_categories_on_create_kpi">
                <label>{{ __("forms.EvaluationChart.questions.questions_setting.question12.tableKPI.categories")
                  }}</label>
                <multiselect v-model="editRowKpi.kpiCategories" placeholder="Search a tag" label="identifiable_name"
                  track-by="id" :options="kpi_categories" :multiple="true" :taggable="true"></multiselect>
              </div>


            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ __("misc.close") }}</button>
            <button type="button" class="btn btn--green" @click="saveKpiText(editRowKpi)">
              {{ __("misc.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  mounted() {
    this.targetBonus = this.target_bonus;
  },
  props: {
    is_admin: {
      type: Boolean,
      required: true,
    },
    read_target: {
      type: Boolean,
      required: true,
    },
    show_ral: {
      type: Boolean,
      required: true,
    },
    show_target_bonus: {
      type: Boolean,
      required: true,
    },
    show_target_euro: {
      type: Boolean,
      required: true,
    },
    limit_indicators: {
      type: Boolean,
      required: true,
    },
    lock_weights: {
      type: Boolean,
      required: true,
    },
    permission_edit_prize: {
      type: Number,
      required: true,
    },
    show_prize_value: {
      type: Boolean,
      required: true,
    },
    show_pie_graph: {
      type: Boolean,
      required: true,
    },
    show_line_chart: {
      type: Boolean,
      required: true,
    },
    show_performance_percent: {
      type: Boolean,
      required: true,
    },
    show_categories_on_create_kpi: {
      type: Boolean,
      required: true,
    },
    show_kpi_classification_in_chart: {
      type: Boolean,
      required: true,
    },
    show_kpi_esg_in_chart: {
      type: Boolean,
      required: true,
    },
    show_reach_percent: {
      type: Boolean,
      required: true,
    },
    show_percent_reach_for_weight: {
      type: Boolean,
      required: true,
    },
    show_unit_measure: {
      type: Boolean,
      required: true,
    },
    show_segmentation_info_in_description_modal: {
      type: Boolean,
      required: true,
    },
    show_measures_and_formulas: {
      type: Boolean,
      required: true,
    },
    show_typology: {
      type: Boolean,
      required: true,
    },
    show_target_100: {
      type: Boolean,
      required: true,
    },
    show_set_consumptive: {
      type: Number,
      required: true,
    },
    show_prize_attribute: {
      type: Number,
      required: true,
    },
    url_add_kpi: {
      type: String,
      required: true,
    },
    url_add_existing_kpi: {
      type: String,
      required: true,
    },
    permission_add_new_kpi: {
      type: Number,
      required: true,
    },
    evaluation_chart_id: {
      type: Number,
      required: true,
    },
    required_classification_on_create_kpi: {
      type: Boolean,
      required: true,
    },
    show_classification_on_create_kpi: {
      type: Boolean,
      required: true,
    },
    show_esg_on_create_kpi: {
      type: Boolean,
      required: true,
    },
    show_categories_on_create_kpi: {
      type: Boolean,
      required: true,
    },
    question_survey_id: {
      type: Number,
      required: true,
    },
    workflow_role_id: {
      type: Number,
      required: true,
    },
    main_permission: {
      type: Number,
      required: true,
    },
    show_external_conditions: {
      type: Array,
      required: true,
    },
    kpi_classifications: {
      type: Array,
      required: true,
    },
    columns_order: {
      type: Array,
      required: true,
    },
    classification_types: {
      type: Array,
      required: true
    },
    kpi_esgs: {
      type: Array,
      required: true,
    },
    kpi_categories: {
      type: Array,
      required: true,
    },
    show_max_min_targets: {
      type: Number,
      required: true,
    },
    show_max_min_prizes: {
      type: Number,
      required: true,
    },
    show_perc_linear_performance : {
      type: Number,
      required: true,
    },

    permission_add: {
      type: Number,
      required: true,
    },
    owner_person_id: {
      type: Number,
      required: true,
    },
    target_bonus: {
      type: Number,
      required: true,
    },

    kpi_incentive_plan_id: {
      type: Number,
      required: true,
    },
    prize_mode: {
      type: String,
      required: true,
    },

    prize_name: {
      type: String,
      required: true,
    },
    pay_item_ral_name: {
      type: String,
      required: true,
    },
    show_prize_assigned: {
      type: Boolean,
      required: true,
    },
    show_sum_percent_reach_for_weight: {
      type: Boolean,
      required: true,
    },
    show_prize_reached: {
      type: Boolean,
      required: true,
    },
    show_prize_final: {
      type: Boolean,
      required: true,
    },
    show_gross_bonus_sum_achieved_on_ral: {
      type: Boolean,
      required: true,
    },
    show_gross_bonus_sum_achieved_plus_internal_conditions_on_ral: {
      type: Boolean,
      required: true,
    },
    show_gross_bonus_sum_achieved_inline: {
      type: Boolean,
      required: true,
    },
    show_bonus_target: {
      type: Boolean,
      required: true,
    },
    show_bonus_weight: {
      type: Boolean,
      required: true,
    },
    show_bonus_rep: {
      type: Boolean,
      required: true,
    },
    approve_kpi: {
      type: Boolean,
      required: true,
    },

    enable_change_target: {
      type: Boolean,
      required: true,
    },
    is_archived: {
      type: Boolean,
      required: false,
      default: true
    },
    icon_status_plan: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      //default
      showPlots: false,
      tableKpi: [],
      tableThreshold: [],
      tableExternalConditions: [],
      organizational_kpi_list: [],
      alerts: [],
      showLoading: true,
      targetBonus: null,
      targetEuro: null,
      targetEuroEnchanted: null,
      newKpiSelected: "",
      editRowKpi: null,
      action: "",
      editing: true,
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
      userUrl: "",
      sumPrize: 0,
      sumPercentReachForWeight: 0,
      extraPrizeName: "",
      sumRepartedPrize: 0,
      isPersonResigned: false,
      sumPrizeFinal: 0,
      userRal: 0,
      customPrize: 0,
      customTargetBonus: 0,
      userRalUnformatted: 0,
      grossBonusSumAchievedOnRal: 0,
      grossBonusSumAchievedPlusInternalConditionsOnRal: 0,
      prettyGrossBonusSumAchievedPlusInternalConditionsOnRal: 0,
      dataLineGraph: null,
      dataPieGraph: null,
      discretionaryPrizeData : null,
    };
  },
  computed: {
    hasShareableKPI() {
      return this.tableKpi.some(row => row.is_kpi_sharable_by_indicator == true);
    }
  },
  methods: {
    showMeasures(txt) {
      Vue.swal.fire({
        title: "Descrizione KPI",
        html: txt,
      });
    },
    showExternalConditionDescription(row) {
      Vue.swal.fire({
        title: row.name,
        html: row.description,
        width: '60%',
        heightAuto: false,
      });
    },
    showDescriptionKpiAndSegmentationGaols(row) {
      app.__vue__.$refs.vue_popup.toggle(row.name, '/kpi-info-chart/' + row.kpi_id + '/kpi/' + row.question_survey_id + "/question_survey");
    },
    mountedDelayed() {
      this.populateKpiTable();
    },
    openAddNewKpi() {

      if (this.is_archived) {
        this.showAlertIsArchived();
        return;
      }

      if (this.isPersonResigned) {
        this.showAlertPersonResigned();
        return;
      }
      app.__vue__.$refs.vue_popup.toggle(this.__("views.KPIs.add_new_kpi"), this.url_add_kpi);
    },
    openAddExistingKpi() {

      if (this.is_archived) {
        this.showAlertIsArchived();
        return;
      }

      if (this.isPersonResigned) {
        this.showAlertPersonResigned();
        return;
      }

      app.__vue__.$refs.vue_popup.toggle("", this.url_add_existing_kpi);
    },
    editKpiInfo(row) {

      if (this.is_archived) {
        this.showAlertIsArchived();
        return;
      }

      this.editRowKpi = row;
      this.$nextTick(() => {
        $('#editKpiModal_' + this.question_survey_id).modal('show');
      });
    },
    showSharableKpi(row) {
      Livewire.emit('setKpiShared', row.kpi_id, row.indicatorId);
      $('#showSharedKpiModal_' + this.question_survey_id).modal("show");
    },
    saveKpiText(editRowKpi) {

      if (this.is_archived) {
        this.showAlertIsArchived();
        return;
      }

      if (this.required_classification_on_create_kpi && this.editRowKpi.kpi_classification_id == null) {
        alert(this.__("forms.EvaluationChart.questions.questions_setting.question12.alert_messages.missing_classification"));
        return;
      }

      editRowKpi.kpiEsgs = editRowKpi.kpiEsgs.map(esg => esg.id);
      editRowKpi.kpiCategories = editRowKpi.kpiCategories.map(category => category.id);

      if (this.main_permission > 1) {
        axios
          .put("/update-kpi-txt-from-chart/" + editRowKpi.kpi_id + "/kpi", {
            kpiInfo: editRowKpi
          })
          .then((response) => {
            this.populateKpiTable();
            $('#editKpiModal_' + this.question_survey_id).modal('hide');
          });
      }



    },
    rmKpiRow(people_kpi_id) {

      if (this.is_archived) {
        this.showAlertIsArchived();
        return;
      }

      if (this.isPersonResigned) {
        this.showAlertPersonResigned();
        return;
      }

      Vue.swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.value) {
            axios
              .delete("/delete-people-kpi-target-chart", {
                params: {
                  people_kpi_id: people_kpi_id,
                },
              })
              .then((response) => {
                this.populateKpiTable();
              })
              .catch(function (error) {
                if (error.response.status == 405) {
                  Vue.swal.fire({
                    title: error.response.data.advice.title,
                    html: error.response.data.advice.html,
                    icon: "error",
                  });
                }
              });;
          }
        });
    },
    updateTargetBonusPerson() {

      if (this.is_archived) {
        this.showAlertIsArchived();
        return;
      }

      axios
        .put("/kpi-people-update-target-bonus-person" + this.userUrl, {
          kpis_incentive_plan_id: this.kpi_incentive_plan_id,
          owner_person_id: this.owner_person_id,
          target_bonus: this.targetBonus,
        })
        .then((response) => {
          this.populateKpiTable();
        });
    },
    updateTargetEuroPerson() {

      if (this.is_archived) {
        this.showAlertIsArchived();
        return;
      }

      axios
        .put("/kpi-people-update-target-euro-person" + this.userUrl, {
          kpis_incentive_plan_id: this.kpi_incentive_plan_id,
          owner_person_id: this.owner_person_id,
          target_euro: this.targetEuro,
        })
        .then((response) => {
          this.populateKpiTable();
        });
    },
    showAlertPersonResigned() {
      Vue.swal.fire({
        title: this.__("forms.EvaluationChart.questions.questions_setting.question12.alert_messages.personResigendNoEdit"),
      });
    },
    showAlertIsArchived(row) {
      let vueComponent = this;
      Vue.swal.fire({
        title: this.__("forms.KPIIncentivePlan.status_plan_archived"),
        text: this.__("forms.KPIIncentivePlan.element_related_to_plan_archived_info"),
        icon: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ok",
      }).then(function (response) {
        vueComponent.showTargetModal(row);
      });
    },
    openTargets(row) {
      if (this.is_archived) {
        this.showAlertIsArchived(row);
      } else {
        this.showTargetModal(row);
      }
    },
    showTargetModal(row) {
      app.__vue__.$refs.vue_popup.toggle(
        this.__("forms.KPIS.consumptives_title") + ': ' + row.name,
        "/kpis-target-question-consumptives/" + row.kpi_id + "/kpi?chartConsumptives[question_survey_id]=" + this.question_survey_id
        + "&chartConsumptives[workflow_role_id]=" + this.workflow_role_id
        + "&chartConsumptives[evaluation_chart_id]=" + this.evaluation_chart_id
        + "&chartConsumptives[kpi_incentive_plan_id]=" + this.kpi_incentive_plan_id
      );
    },
    updatePrizeAttribute(event, person_kpi_id) {

      if (this.is_archived) {
        this.showAlertIsArchived();
        return;
      }

      axios
        .post(
          "/kpis-target-question-update-prize-attribute/" +
          person_kpi_id +
          "/person-kpi" +
          this.userUrl,
          {
            prize_attribute: event.target.value,
            prize_mode: this.prize_mode,
          },
        )
        .then((response) => {
          this.populateKpiTable();
        });
    },
    benchmarkTargetBonus() {
      let targetBonus = (this.customPrize / this.userRalUnformatted) * 100;
      this.customTargetBonus = targetBonus.toFixed(2);
    },
    populateKpiTable() {
      this.showLoading = true;
      axios
        .get("/kpis-list-calculate" + this.userUrl, {
          params: {
            kpi_incentive_plan_id: this.kpi_incentive_plan_id,
            owner_person_id: this.owner_person_id,
            // "thresholds"  : this.thresholds,
            prize_mode: this.prize_mode,
            evaluation_chart_id: this.evaluation_chart_id,
            question_survey_id: this.question_survey_id,
          },
        })
        .then((response) => {
          this.tableKpi = response.data.tableKpi;
          this.staticGoalsArray = response.data.staticGoalsArray;

          this.tableThreshold = response.data.tableThreshold;
          this.tableExternalConditions = response.data.tableExternalConditions;
          this.userRal = response.data.userRal;
          this.grossBonusSumAchievedOnRal =
            response.data.grossBonusSumAchievedOnRal;
          this.grossBonusSumAchievedPlusInternalConditionsOnRal =
            response.data.grossBonusSumAchievedPlusInternalConditionsOnRal;
          this.prettyGrossBonusSumAchievedPlusInternalConditionsOnRal =
            response.data.prettyGrossBonusSumAchievedPlusInternalConditionsOnRal;
          this.sumPrize = response.data.sumPrize;
          this.sumPercentReachForWeight = response.data.sumPercentReachForWeight;
          this.sumRepartedPrize = response.data.sumRepartedPrize;
          this.sumPrizeFinal = response.data.sumPrizeFinal;
          this.targetBonus = response.data.targetBonus;
          this.targetEuro = response.data.targetEuro;
          this.targetEuroEnchanted = response.data.targetEuroEnchanted;
          this.alerts = response.data.alerts;

          this.userRalUnformatted = response.data.userRalUnformatted;
          this.extraPrizeName = response.data.extraPrizeName;
          //graph data
          this.dataLineGraph = response.data.dataLineGraph;
          this.dataPieGraph = response.data.dataPieGraph;
          this.isPersonResigned = response.data.isPersonResigned;
          this.discretionaryPrizeData = response.data.discretionaryPrizeData;
          //Refresh select of sharable KPIS
          Livewire.emit('updatePersonKpiShared');

          //RefreshGlobalRatings
          Livewire.emit('refreshGlobalRating');



          this.showLoading = false;
        });
    },
    plot() {
      this.showPlots = !this.showPlots;
      if (this.showPlots === true) {
        if (this.show_line_chart) {
          this.$refs[
            "mbo_line_targets_" + this.question_survey_id
          ].drawLineGraph(this.dataLineGraph);
        }
        if (this.show_pie_graph) {
          this.$refs["mbo_pie_targets_" + this.question_survey_id].drawPieGraph(
            this.dataPieGraph,
          );
        }
      }
    },
  },
};
</script>

<style scoped>
@import "./responsive-table.css";

.border-card {
  border: none !important;
  border-left: 4px solid #1767a2 !important;
}

.table-scroll {
  table-layout: auto !important;
  border-radius: 0.2rem;
  width: 100%;
  padding-bottom: 1rem;
  color: #212529;
  margin-bottom: 0;
}

.table-scroll th:first-child,
.table-scroll td:first-child {
  position: sticky;
  left: 0;
  z-index: 10;
  background-color: #f8f9fa;
  min-width: 350px !important;
  max-width: 400px !important;
}

.table-scroll td {
  white-space: nowrap;
}

table.table-scroll thead th,
table.table-scroll tfoot th {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-color: #5d95be !important;
  color: white !important;
}

table.table-scroll tbody td,
table.table-scroll tfoot td {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 100px !important;
  max-width: 100px !important;
}

table.table-scroll.table-popup thead th,
table.table-scroll.table-popup tfoot th {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 70px !important;
  max-width: 100px !important;
  background-color: #5d95be !important;
  color: white !important;
}

table.table-scroll.table-popup tbody td,
table.table-scroll.table-popup tfoot td {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 70px !important;
  max-width: 100px !important;
}

.table-custom-header thead tr th {
  background: #5d95be;
  color: white !important;
}
</style>
